function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M28.88 0H3.13A3.12 3.12 0 000 3.13v25.75C0 30.6 1.4 32 3.13 32h25.75C30.6 32 32 30.6 32 28.87V3.13C32 1.4 30.6 0 28.87 0z",
  fill: "url(#paint0_linear_384_120)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_384_120",
  x1: "16",
  y1: "0",
  x2: "16",
  y2: "32",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A731"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#EE7B2E"
})))), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "24",
  fill: "none",
  x: "7",
  y: "4"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.08 18.44L.05 12.41a.03.03 0 00-.04 0V23.3a.7.7 0 001.09.58l7.98-5.44z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.01 10L0 12.37l9.08 6.06 3.72-2.53-8.79-5.92z",
  fill: "#FCE2C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7 11.42L1.1.12A.7.7 0 000 .7v6.64a.03.03 0 00.01.02L12.8 15.9a.03.03 0 00.03 0l4.88-3.32a.7.7 0 000-1.16z",
  fill: "#fff"
})));